export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-3xl overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-background-50 rounded-full -translate-y-1/2 translate-x-1/4"></div>
            <div className="absolute bottom-0 left-0 w-72 h-72 bg-background-50 rounded-full translate-y-1/3 -translate-x-1/4"></div>
          </div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12 px-6 md:px-10 py-12 md:py-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
                随时随地 · 畅享高清影视
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
                访问黑桃视频手机网页版，西瓜视频免费、丝瓜视频高清全集在线观看，
                不缓冲流畅播放，最新电视剧电影大全手机端同步更新。无需下载APP，
                浏览器打开即可享受高清观影体验。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-smartphone-line text-lg"></i>
                  手机端立即体验
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 w-full max-w-[340px]">
              <div className="relative mx-auto w-[220px]">
                <div className="absolute inset-0 bg-background-50/20 rounded-[2.5rem] blur-xl"></div>
                <div className="relative bg-background-50 rounded-[2rem] p-3 shadow-lg">
                  <div className="bg-background-100 rounded-2xl overflow-hidden aspect-[9/16]">
                    <div className="w-full h-full bg-gradient-to-b from-primary-100 via-background-50 to-accent-100 flex flex-col items-center justify-center p-6 text-center">
                      <div className="w-14 h-14 rounded-2xl bg-primary-500 flex items-center justify-center mb-4">
                        <i className="ri-play-fill text-background-50 text-2xl"></i>
                      </div>
                      <p className="text-sm font-medium text-foreground-900 mb-1">黑桃视频</p>
                      <p className="text-xs text-foreground-500">高清不缓冲 · 随时随地看</p>
                      <div className="mt-4 w-full flex flex-col gap-2">
                        <div className="w-full h-2 bg-background-200 rounded-full"></div>
                        <div className="w-3/4 h-2 bg-background-200 rounded-full"></div>
                        <div className="w-1/2 h-2 bg-background-200 rounded-full"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}